import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltCommentsSidebarV2PageModeComposer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-page-mode-composer-v2-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2PageModeComposer;
